import Vue from 'vue'
import App from './App.vue'
import store from './state/store'
import router from './router/routes'
import BootstrapVue from 'bootstrap-vue'
import helpers from './helper'
import '@/design/index.scss'
import VueApexCharts from 'vue-apexcharts'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { datadogRum } from '@datadog/browser-rum'
const SentryWebpackPlugin = require('@sentry/webpack-plugin')

const version = process.env.VUE_APP_RELEASE ? process.env.VUE_APP_RELEASE : '2021.11.12'
const name = 'stylist'

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: `${name}@${version}`,
  devtool: 'source-map',
  plugins: [
    new SentryWebpackPlugin({
      authToken: process.env.VUE_APP_SENTRY_TOKEN,
      org: 'fashionphilecom',
      project: name,
      release: `${name}@${version}`,
      ignore: ['node_modules', 'vue.config.js'],
      environment: process.env.NODE_ENV
    })
  ],
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['stylist.fashionphile.com']
    })
  ],
  tracesSampleRate: 1.0,
  tracingOptions: {
    trackComponents: true
  }
})

datadogRum.init({
  applicationId: '40dabd4d-83d4-47cf-ac8f-761ec056ab53',
  clientToken: 'pub5e5dc407a4dc102a6a3fb82995a1d316',
  site: 'datadoghq.com',
  service: name,
  env: process.env.NODE_ENV,
  version: version,
  sampleRate: 100,
  replaySampleRate: 80,
  trackInteractions: true
})

if (process.env.NODE_ENV === 'production') {
  datadogRum.startSessionReplayRecording()
}

Vue.component('apexchart', VueApexCharts)
Vue.use(VueApexCharts)
Vue.use(BootstrapVue)

export const bus = new Vue()
const plugin = {
  install () {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}

Vue.use(plugin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
